import { createContext } from 'react'



export const urlApi = createContext(null)